export default __webpack_public_path__ + "static/staffy-logo-orange-a27f6697a76481ffe66ef471417d3a9f.svg";